import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppPricingPlan } from '@/constants/enum';
import { Subscription } from '@/constants/enum';
import { DiscountCodeType } from '@/constants/enum';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface PricingState {
  plan: AppPricingPlan;
  subscription: Subscription;
  discount: {
    value: number;
    discountType: DiscountCodeType;
    applyFor?: AppPricingPlan[];
  };
}

export const initialState: PricingState = {
  plan: AppPricingPlan.Free,
  subscription: Subscription.Monthly,
  discount: {
    value: 0,
    discountType: DiscountCodeType.PERCENTAGE,
    applyFor: [],
  },
};

export const pricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {
    setPlan: (state, action: PayloadAction<AppPricingPlan>) => {
      state.plan = action.payload;
    },
    setSubscription: (state, action: PayloadAction<Subscription>) => {
      state.subscription = action.payload;
    },
    setDiscount: (
      state,
      action: PayloadAction<{
        value: number;
        discountType: DiscountCodeType;
        applyFor?: AppPricingPlan[];
      }>,
    ) => {
      state.discount = action.payload;
    },
    setPricing: (state, action: PayloadAction<Partial<PricingState>>) => {
      state = { ...state, ...action.payload };
      return state;
    },
  },
});

export const pricingSelector = createSelector(
  (state: RootState) => state.pricing,
  (state) => state,
);

export const pricingPlanSelector = createSelector(
  (state: RootState) => state.pricing,
  (state) => state.plan,
);

export const pricingSubscriptionSelector = createSelector(
  (state: RootState) => state.pricing,
  (state) => state.subscription,
);

export const pricingDiscountSelector = createSelector(
  (state: RootState) => state.pricing,
  (state) => state.discount,
);

export const { setPlan, setSubscription, setDiscount, setPricing } = pricingSlice.actions;

export default pricingSlice;
